import { render, staticRenderFns } from "./RegistrationTimeChange.vue?vue&type=template&id=9fa7de50"
import script from "./RegistrationTimeChange.vue?vue&type=script&lang=js"
export * from "./RegistrationTimeChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports